import React, {Fragment, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import ViewIcon from "../../assets/image/icon_eye.svg";
import Split from "../../assets/image/split.svg";
import Delete from "../../assets/image/icon_trash.svg";
import {Moments} from "@common/utils/date/moments";
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {convertPath} from "@common/utils/path/linkPath";

function SmallCardHorizontal({source = [] || {}, isMine, link}) {

  /*const convertJSONKey = (object, oldKey, newKey) => {
    object[newKey] = object[oldKey];
  }*/

  // Covert Keys
  //convertJSONKey("source", "oldKey", "newKey");

  return (
    <>
      {source.map((eachData, i) => {
          return (
            <a href={convertPath(`${link}${eachData.ukey}`)} key={`ad-${eachData.ukey}`}>
              <div className="ad-box small-horizontal">
                <div className="thumbnail-card-wrapper">
                  <LazyLoadImage className="thumbnail-card small-video" src={`${eachData.thumbnail.replace('/l/', '/m/').replace("http:", "https:")}`}/>
                </div>
                  <div className={`ad-info ${isMine ? "has-delete" : ""}`}>
                    <div className="left-box">
                      <h4 className="title">{eachData.title}</h4>
                      <h5 className="company">{eachData.brand}</h5>
                      <div className="row-box">
                        {
                          eachData.rcount !== 0 &&
                          <>
                            <div className="view-count">
                              <img src={ViewIcon} alt=""/>
                              <span>{eachData.rcount}</span>
                            </div>
                            <img src={Split} alt=""/>
                          </>
                        }
                        <div className="created-date">{Moments.Format(eachData.wdate, 'yyyy.MM.DD')}</div>
                      </div>
                    </div>
                    {
                      isMine &&
                      <i><img src={Delete}/></i>
                    }
                  </div>
              </div>
            </a>
          )
        }
      )}
    </>
  );
}

export default SmallCardHorizontal;

